import { EnvironmentsContext } from '@/contexts/EnvironmentsContext'
import { Button, Icon, Typography } from '@flatfile/design-system'
import { useContext } from 'react'
import styled, { css } from 'styled-components'

const largeButtonStyles = css`
  button {
    height: 40px;
    padding: 12px 20px;
  }
`

const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: var(--color-page-100);
  padding: 24px;
  gap: 16px;
  margin-bottom: 24px;
`

const BannerButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  ${largeButtonStyles}
`

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-top: 16px;

  ${largeButtonStyles}
`

const onClickLearnMore = () => {
  const infoUrl = 'https://flatfile.com/platform/projects/'
  window.open(infoUrl, '_blank')
}

const onContactSales = (email?: string) => {
  const contactUrl = `https://flatfile.com/contact-sales/consult/${
    email ? `?email=${email}` : ''
  }`
  window.open(contactUrl, '_blank')
}

export const UpgradeBanner = ({
  hasProjectsEnabled,
  onUpgradeProject,
}: {
  hasProjectsEnabled: boolean
  onUpgradeProject: () => void
}) => {
  const { account } = useContext(EnvironmentsContext)
  return (
    <BannerContainer data-testid='upgrade-banner'>
      <Icon name='userGroup' size={24} />
      <Typography type='h3Serif'>
        Enjoy a zero trust collaborative Project
      </Typography>
      <Typography type='b0' color='var(--color-text-light)'>
        {hasProjectsEnabled
          ? 'Start a project to collaborate on data with your team. Interested in transforming this Space into a Project?'
          : 'Talk to one of our product experts to learn how Flatfile Projects transforms data onboarding as you know it.'}
      </Typography>
      <BannerButtons>
        {hasProjectsEnabled ? (
          <Button
            size='lg'
            label='Contact support'
            iconLeft='mail'
            onPress={() => onUpgradeProject()}
          />
        ) : (
          <Button
            size='lg'
            label='Contact sales'
            iconLeft='mail'
            onPress={() => onContactSales(account?.name)}
          />
        )}
        <Button
          size='lg'
          variant='ghost'
          label='Learn more'
          onPress={() => onClickLearnMore()}
        />
      </BannerButtons>
    </BannerContainer>
  )
}

export const EndProjectFooter = ({
  onClickEndProject,
}: {
  onClickEndProject: () => void
}) => {
  return (
    <FooterContainer data-testid='end-project-footer'>
      <Button
        size='lg'
        variant='warning'
        label='End Project'
        onPress={onClickEndProject}
      />
      <Typography type='b1' color='var(--color-text-light)'>
        When you end a Project, all guests invited to the Space will no longer
        have access to the Space. This is not a reversible action.
      </Typography>
    </FooterContainer>
  )
}
